// The icon and tint for a kind of task, by its one-word tag (KINDS[kind].tag in screens/approvals/Approvals.tsx).
// Direction A: seal for replies and things Ogma wrote, ochre for drafts waiting on you, moss for meetings, neutral
// for the rest. Shared by the approval queue and the screens that list tasks.
import { Briefcase, CalendarDays, Inbox, MessageCircle, PenLine, Radar, Reply, TriangleAlert, Users } from "lucide-react";
import type { IconTone, KitIcon } from "../components/kit";

export function kindLook(tag: string | undefined): { icon: KitIcon; tone: IconTone } {
  switch (tag) {
    case "Outreach":
    case "By hand":
    case "Post":
    case "Re-post":
    case "Pitch":
      return { icon: PenLine, tone: "ochre" };
    case "Search":
      return { icon: Radar, tone: "ochre" };
    case "Reply":
    case "Answer":
    case "Answers":
      return { icon: Reply, tone: "seal" };
    case "WhatsApp":
      return { icon: MessageCircle, tone: "seal" };
    case "Meeting":
    case "Booking":
      return { icon: CalendarDays, tone: "moss" };
    case "Contact":
    case "LinkedIn":
      return { icon: Users, tone: "neutral" };
    case "Alert":
    case "Budget":
      return { icon: TriangleAlert, tone: "neutral" };
    case "Deal":
    case "Quote":
    case "Offer":
    case "Tender":
      return { icon: Briefcase, tone: "neutral" };
    default:
      return { icon: Inbox, tone: "neutral" };
  }
}
